export const faqs = [
  {
    id: 1,
    question: '久久爱的伴侣匹配是如何工作的？',
    answer: '久久爱采用基于心理学和行为科学的深度匹配算法。您需要完成一套涵盖人格特质、价值观、情感模式和生活方式的综合评估，系统会根据您在多个维度的特征，为您推荐匹配度最高的潜在伴侣。我们的算法特别加入了"长久关系预测模型"，不仅关注匹配度，更关注关系的可持续发展潜力。',
  },
  {
    id: 2,
    question: '情感指导服务是线上还是线下？',
    answer: '久久爱提供灵活的服务模式：您可以选择线上视频咨询（随时随地、便捷高效），也可以选择线下面对面指导（目前覆盖北京、上海、广州、深圳、成都、杭州等主要城市）。我们的情感咨询师均持有国家心理咨询师资格证书，拥有丰富的实战经验。',
  },
  {
    id: 3,
    question: '感情修复指导需要双方都参与吗？',
    answer: '理想情况下，双方共同参与效果最佳。但如果您的伴侣暂时不愿意参与，您也可以先行开始个人指导——很多案例表明，当一方开始改变自己的沟通方式和行为模式后，另一方往往会受到积极影响，进而愿意参与进来。',
  },
  {
    id: 4,
    question: '久久爱的服务费用是多少？',
    answer: '久久爱提供多样化的服务套餐：基础会员免费注册，可浏览精选情感文章和参与社区讨论；伴侣匹配服务根据匹配深度和次数收费；情感指导和修复课程按照咨询时长或课程套餐收费。具体价格请访问久久爱官网查看最新方案，或联系客服获取个性化建议。',
  },
  {
    id: 5,
    question: '我的个人信息安全吗？',
    answer: '绝对安全。久久爱采用行业领先的数据加密技术保护您的个人信息。您的评估数据、聊天记录、咨询内容等隐私信息均经过加密处理，未经您的明确授权，任何第三方（包括匹配对象）都无法获取您的敏感信息。我们严格遵守个人信息保护相关法律法规。',
  },
  {
    id: 6,
    question: '久久爱适合什么年龄段的人使用？',
    answer: '久久爱主要面向20至45岁的都市人群，但只要是渴望寻找真爱、维系感情或修复关系的成年人，都可以在久久爱找到适合自己的服务。我们有针对不同年龄段和人生阶段（恋爱期、婚姻期、感情危机期等）的定制化方案。',
  },
  {
    id: 7,
    question: '匹配成功率有多高？',
    answer: '根据久久爱平台数据统计，匹配度在85%以上的用户中，超过72%在首次见面后愿意继续交往，超过45%建立了稳定的恋爱关系。当然，匹配只是第一步，真正的长久幸福还需要双方的用心经营。久久爱会从匹配到陪伴，全程支持你的情感旅程。',
  },
  {
    id: 8,
    question: '如果匹配的人不适合我可以重新匹配吗？',
    answer: '当然可以！久久爱理解每一次相遇都是一次学习和成长。如果您觉得当前的匹配对象不适合，可以随时请求重新匹配。同时，您在互动过程中的反馈会被系统学习，帮助下一次匹配更加精准。我们的目标是助力你找到真正适合的伴侣，而非追求匹配次数。',
  },
];